import React from "react";
import SlideDisplay from "./SlideDisplay";
import PollResults from "./PollResults";
import Gameplay from "./Gameplay";
import VideoPlayer from "./Video/VideoPlayer";
import { DIRECTION } from "../constants";

const MainView = ({
  hideSlideDisplay,
  pollQuestion,
  pollResults,
  isSlidesLoading,
  slideUrl,
  handleSlidePostMessage,
  numOfStudentsData,
  gameRef,
  playtimePhase,
  videoId,
  discussPhase,
  gameplayRoute,
  isGamePlaying,
  setIsGamePlaying,
  timerTimes,
  setDisableArrowControls,
  handleNavigation,
  nextSlideLabel,
  timerModalInfo,
  setTimerModalInfo,
  startTimerModalCallback,
  isShowingGlossary,
  isTutorialTooltipBlockingInputs,
  completeActiveTutorial,
  customizationNumCompleted,
  lessonNum,
  isOnFirstSlide,
  dispatchTeachEventLog,
  setOnFreeplayHandler,
  onFreeplayHandler,
}) => {
  return (
    <div id="main-view">
      <SlideDisplay
        isHidden={hideSlideDisplay}
        isSlidesLoading={isSlidesLoading}
        slideUrl={slideUrl}
        handleSlidePostMessage={handleSlidePostMessage}
        numOfStudentsData={numOfStudentsData}
        discussPhase={discussPhase}
        timerTimes={timerTimes}
        setDisableArrowControls={setDisableArrowControls}
        handleNavigation={handleNavigation}
        timerModalInfo={timerModalInfo}
        setTimerModalInfo={setTimerModalInfo}
        setIsGamePlaying={setIsGamePlaying}
        isTutorialTooltipBlockingInputs={isTutorialTooltipBlockingInputs}
        completeActiveTutorial={completeActiveTutorial}
        isOnFirstSlide={isOnFirstSlide}
        dispatchTeachEventLog={dispatchTeachEventLog}
      />
      {pollResults && (
        <PollResults question={pollQuestion} results={pollResults} />
      )}
      {playtimePhase && (
        <Gameplay
          gameRef={gameRef}
          playtimePhase={playtimePhase}
          gameplayRoute={gameplayRoute}
          isGamePlaying={isGamePlaying}
          setIsGamePlaying={setIsGamePlaying}
          timerTimes={timerTimes}
          setDisableArrowControls={setDisableArrowControls}
          handleNavigation={handleNavigation}
          nextSlideLabel={nextSlideLabel}
          timerModalInfo={timerModalInfo}
          setTimerModalInfo={setTimerModalInfo}
          startTimerModalCallback={startTimerModalCallback}
          isShowingGlossary={isShowingGlossary}
          isTutorialTooltipBlockingInputs={isTutorialTooltipBlockingInputs}
          completeActiveTutorial={completeActiveTutorial}
          customizationNumCompleted={customizationNumCompleted}
          lessonNum={lessonNum}
          isOnFirstSlide={isOnFirstSlide}
          dispatchTeachEventLog={dispatchTeachEventLog}
          setOnFreeplayHandler={setOnFreeplayHandler}
          onFreeplayHandler={onFreeplayHandler}
        />
      )}
      {videoId && (
        <VideoPlayer
          videoId={videoId}
          handleNavigationNext={() => handleNavigation(DIRECTION.NEXT)}
          setDisableArrowControls={setDisableArrowControls}
        />
      )}
    </div>
  );
};

export default MainView;
